import {CookieManager} from '../modules/cookie.js';
import {MouseEventsHelper} from '../modules/mouseEventsHelper.js';
import {requestDialog} from '../modules/dialog.js';

/**
 * Displays a roadblock. By default it displays the newsletter subscription roadblock,
 * which is the one we use across the entire platform.
 *
 * @param {string} roadblockId The id of the roadblock we want to display.
 * @param {string} roadblockCookie The cookie that will be associated to this modal.
 */
function showRoadBlock(roadblockId, roadblockCookie) {
    if (CookieManager.read(roadblockCookie) === null) {
        CookieManager.write(roadblockCookie, 'yes', {days: 365});
        requestDialog(roadblockId);
    }
}

/**
 * Register Handlers to display a generic roadblock if
 * the generic 'isRoadblockSeen' cookie is not set, meaning
 * the roadblock has been dismissed before.
 *
 * @param {string} roadblockDialogId
 * @param {string} cookieNameToStoreState
 */
function registerHandlersToDisplayRoadblock(roadblockDialogId, cookieNameToStoreState) {
    const hasSubscribedToNewsletter = !!CookieManager.read('has_subscribed_to_newsletter');

    if (hasSubscribedToNewsletter) {
        return;
    }

    // Attach handler to call showRoadblock when
    // mouse scrolls half-way down the page.
    MouseEventsHelper.onMouseScrollHalfWayDownPageHeight(showRoadBlock, roadblockDialogId, cookieNameToStoreState);

    // Attach handler to call showRoadblock when
    // mouse exits the window boundaries.
    MouseEventsHelper.onMouseExitsWindow(showRoadBlock, roadblockDialogId, cookieNameToStoreState);
}

/**
 * Init page, register event handlers
 */
function initPage() {
    registerHandlersToDisplayRoadblock('roadblockModal', 'wasRoadblockModalDisplayed');
}

// init page when the document is ready
document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initPage) : initPage();
